import type { TagsEnum } from '@shared/enums/tags.enum';
import type { HubFiltersType } from '@shared/ui/popovers/HubFilterPopover/types';

export type BillsFiltersType = {
  hubs?: TagsEnum[] | null;
  item_ids?: number[] | null;
  sort_by?: string | null;
  query?: string | null;
  linking?: HubFiltersType;
};

export type BillsStateType = {
  paymentHistoryData: any;
  isListOver: boolean | number;
  dashboardInfo: any;
  billsItem: any;
  query?: string | null;
  isFetchingWithFilter: boolean;
  isFetchingInitialData: boolean;
  billsList: any;
  filters: BillsFiltersType;
  createInsuranceBill: any;
};
export enum RecurrenceSortByEnum {
  all = 'all',
  due_date = 'due-date',
  type = 'type',
  account = 'account',
  hub = 'hub',
}

export const recurrenceSortByOptions = [
  { value: RecurrenceSortByEnum.all, label: 'All' },
  { value: RecurrenceSortByEnum.due_date, label: 'Sort by Due date' },
  { value: RecurrenceSortByEnum.type, label: 'Sort by Type' },
  { value: RecurrenceSortByEnum.account, label: 'Sort by Account' },
  { value: RecurrenceSortByEnum.hub, label: 'Sort by Hub' },
];
